exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-regulation-view[data-v-320c4b86] {\n  min-height: 100vh;\n  background: #fbfafc;\n}\n", ""]);

// exports
